import React from 'react';
import classNames from "classnames";
import CustomJustify from "@/pages/datalab/components/CustomJustify";
import './index.scss';

/**
 * 图表配置中经常新增 配置项模块
 * 所以结合一些固定样式和交互 写一个可复用的UI组件
 */

const ConfigCard = (props: any) => {
  const { title, operation, className, ...rest } = props;
  return (<div
    className={classNames('dbl-config-card', className)}
    {...rest}
  >
    <CustomJustify
      className="dbl-config-card-header"
      left={title}
      right={operation}
    />
    {props.children}
  </div>);
};


export default ConfigCard;